import React, { FC, Fragment, forwardRef } from 'react';
import * as format from '@format';
import CalendarBlank from '@components/Icons/CalendarBlank';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Buttons from '@components/Buttons';
import s from './DatePicker.module.scss';

type Props = {
  value?: string | null;
  onChange: (str: string) => void;
  max?: string;
  min?: string;
  inlineLabel?: boolean;
  label: string;
  endOfDay?: boolean;
};

const formatDate = (date: Date | null, onChange: (arg0: string)=>void, endOfDay: boolean): void => {
  if (endOfDay) {
    const tempDate = date || new Date();
    tempDate.setDate(tempDate.getDate() + 1);
    tempDate.setTime(tempDate.getTime() - 1);
    return onChange(date ? tempDate.toISOString() : '');
  }
  return onChange(date ? date?.toISOString() : '');

};

const DatePicker: FC<Props> = ({ onChange, value, label, inlineLabel, max, min, endOfDay = false}) => {
  const Component = inlineLabel ? Fragment : 'div';
  const CustomInput = forwardRef<HTMLButtonElement, { onClick?: () => void }>(({ onClick }, ref) => (
    <Buttons isWrapper className={s.button} onClick={onClick} ref={ref}>
      <CalendarBlank size={16} />
      {inlineLabel && <p className="caption">{label}:</p>}
      <p className="caption">{value ? format.datetimeLocalTZ.abbreviated(value) : 'NA'}</p>
    </Buttons>
  ));

  CustomInput.displayName = 'CustomInput';

  return (
    <div className={s.datepicker}>
      <Component {...(inlineLabel ? {} : { className: s.label })}>
        {!inlineLabel && <span className="caption">{label}</span>}
        <ReactDatePicker
          showPopperArrow={false}
          customInput={<CustomInput />}
          minDate={new Date(`${min}T00:00:00`)}
          maxDate={ endOfDay ? new Date(`${max}T23:59:59`) : new Date(`${max}T00:00:00`)}
          value={value || undefined}
          openToDate={value ? new Date(value) : undefined}
          onChange={date => { formatDate(date, onChange, endOfDay); }}
        />
      </Component>
    </div>
  );
};

export default DatePicker;
